import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Messenger from "../components/Messenger";
import AdminCompanySetup from "../components/admin/AdminCompanySetup";
import SsoLoginPage from "../components/account/SsoLoginPage";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Messenger />} />
      <Route path="/admin/setup-company" element={<AdminCompanySetup />} />
      <Route path="/sso-login" element={<SsoLoginPage />} />
    </Routes>
  );
};

export default AppRoutes;
